<template>
  <v-card width="620" class="mx-auto" :loading="loading" :disabled="loading">
    <v-card-title>
      ข้อมูลจำนวนนักศึกษาทั้งหมดแยกตาม ระดับ คณะ สาขาวิชา/หลักสูตร แขนง
      แผนการเรียน ประเภทรับเข้า ชั้นปี และเพศ
    </v-card-title>
    <v-card-subtitle>(ตั้งแต่ปีการศึกษา 2566 เป็นต้นไป)</v-card-subtitle>
    <v-card-text>
      <v-autocomplete
        v-model="selected_year"
        v-bind:label="'ปีการศึกษา'"
        v-bind:items="years"
        v-bind:item-value="(item) => item"
        v-bind:item-title="(item) => item"
        outlined
      ></v-autocomplete>

      <v-btn color="green darken-3" class="white--text" @click="download()" :disabled="!selected_year">
        ดาวน์โหลด<v-icon> mdi-microsoft-excel</v-icon>
      </v-btn>
      <span class="pl-5" v-if="selected_year"
        >ข้อมูล ณ วันที่ {{ dt(created_at) }}</span
      >
    </v-card-text>
  </v-card>
</template>

<script>
import ReportProvider from "@/services/report.provider.js";
const ReportService = new ReportProvider();
import { dateFromDBTranslator as dt } from "@/helper/translator";
import { statisticSplitCurrExcel } from "./generate.js";

export default {
  name: "StatisticSplitCurr",

  data: () => ({
    loading: false,
    years: [],
    selected_year: null,
    created_at: null,
  }),

  computed: {
    isAuthorizedOfficer() {
      return this.$store.state.user.is_authorized_officer;
    },
  },

  watch: {
    selected_year() {
      if (this.selected_year) {
        this.getYearCreatedDate();
      }
    },
  },

  methods: {
    dt,
    statisticSplitCurrExcel,

    async getYears() {
      this.loading = true;
      const data = await ReportService.getStatisticSplitCurrYear().catch(
        (error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        }
      );
      if (data) {
        this.years = data;
      }
      this.loading = false;
    },

    async getYearCreatedDate() {
      this.loading = true;
      const data = await ReportService.getStatisticSplitCurrCreatedDate(
        this.selected_year
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });
      if (data) {
        this.created_at = data.created_at;
      }
      this.loading = false;
    },

    async download() {
      this.loading = true;
      const data = await ReportService.getStatisticSplitCurr(
        this.selected_year
      ).catch((error) => {
        this.$toasted.error(JSON.stringify(error.response.data.message), {
          duration: 0,
        });
        this.loading = false;
      });
      statisticSplitCurrExcel(data, this.selected_year, this.isAuthorizedOfficer);
      this.loading = false;
    },
  },

  created() {
    this.getYears();
  },
};
</script>
